import { FormCurrencyAmount } from '@wdx/shared/utils';
import {
    ValueParserFunc,
    ValueParserParams,
    ValueSetterFunc,
    ValueSetterParams,
} from 'ag-grid-community';
import * as R from 'ramda';

export const PARSE_EDITOR_VALUE_TO_CURRENCY: ValueParserFunc<
    any,
    FormCurrencyAmount
> = (params: ValueParserParams) => {
    let amount: number | undefined = params.newValue as unknown as number;
    if (R.isNotNil(params.newValue)) {
        const converted = parseFloat(params.newValue);
        amount = Number.isNaN(converted) ? undefined : converted;
    }
    const isoCode = params?.oldValue?.isoCode
        ? { isoCode: params.oldValue.isoCode }
        : {};

    return {
        ...isoCode,
        amount,
    } as FormCurrencyAmount;
};

export const CURRENCY_EDITOR_VALUE_SETTER = (defaultIsoCode: string) =>
    ((params: ValueSetterParams) => {
        let amount: number | undefined = params.newValue as unknown as number;
        if (R.isNotNil(params.newValue)) {
            const converted = parseFloat(params.newValue);
            amount = Number.isNaN(converted) ? undefined : converted;
        }
        const isoCode = params?.oldValue?.isoCode
            ? params.oldValue.isoCode
            : defaultIsoCode;

        const newValue = {
            isoCode,
            amount,
        } as FormCurrencyAmount;

        const field = params.column.getColId();
        params.data[field] = newValue;

        return true;
    }) as ValueSetterFunc<any, FormCurrencyAmount>;
